import React from "react";
import { useParams } from "react-router-dom";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { Routing } from "../../data/Constants/Routing";
import { useApiStates } from "../../state/Store";
import RoleForm from "./RoleForm";

interface Params extends Record<string, string | undefined> {
    roleId: string;
}

const EditRoleScreen: React.FC = () => {
    const params = useParams<Params>();

    const api = useApiStates("roles");
    const role = api.roles.value?.find(r => r.id === params.roleId);

    return (
        <SettingsPage
            breadcrumbs={[{
                title: "Rollen",
                link: Routing.Administration.Role.Navigate()
            }]}
            title={role?.name ?? "Rolle bearbeiten"}>

            <SettingsPageContent
                api={api}
                error={!role && "Rolle nicht gefunden!"}>

                <RoleForm scenario={role}/>

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default EditRoleScreen;
